module.exports = __webpack_public_path__ + "img/wheel.png";